import React from 'react'
import { memo, useMemo } from 'react'
import { HistoricoPanelProps } from 'view/atendimentos/detail/historico/model/model-historico'

import HistoricoAtendimentoDomiciliarADPanel from './app/HistoricoAtendimentoDomiciliarADPanel'
import HistoricoAtendimentoDomiciliarDwPanel from './dw/HistoricoAtendimentoDomiciliarDwPanel'

function HistoricoAtendimentoDomiciliarPanel(props: HistoricoPanelProps) {
  const { isAtendRecente, idAtend, idadeOrigemAtendimento, uuidRegistro, cpfOuCnsCidadao } = props

  const atendimentoPecProcessado: boolean = !isAtendRecente && idAtend

  const selectContent = useMemo(() => {
    return isAtendRecente || atendimentoPecProcessado ? (
      <HistoricoAtendimentoDomiciliarADPanel idAtend={idAtend} idadeOrigemAtendimento={idadeOrigemAtendimento} />
    ) : (
      <HistoricoAtendimentoDomiciliarDwPanel
        uuidRegistro={uuidRegistro}
        cpfOuCnsCidadao={cpfOuCnsCidadao}
        idadeOrigemAtendimento={idadeOrigemAtendimento}
      />
    )
  }, [isAtendRecente, atendimentoPecProcessado, idAtend, idadeOrigemAtendimento, uuidRegistro, cpfOuCnsCidadao])

  return selectContent
}

export default memo(HistoricoAtendimentoDomiciliarPanel)
